import { ReactElement, useMemo } from 'react'
import styled from 'styled-components'
import { Button } from '../../../ui-components/forms/Button'
import { ProductLocationModel } from 'interfaces'
import LocationInfo, { MyStoreTag } from '../common/LocationInfo'

interface StoreInfoCardProps {
  location: ProductLocationModel
  selected?: boolean
  onLocationChange: () => void
}

export const StoreInfoCard = (props: StoreInfoCardProps): ReactElement => {
  const { location, selected = false, onLocationChange } = props

  const isQtyAvailable = location.qtyAvailable > 0
  const isPrimary = location.locType === 'primary'
  const isViewOnly = location.locType === 'viewOnly'

  const disableStore = (!isPrimary && location.qtyAvailable === 0) || isViewOnly

  const onClick = !disableStore ? onLocationChange : undefined

  const buttonText = useMemo(
    () => getButtonText(disableStore, isViewOnly, selected),
    [disableStore, isViewOnly, selected]
  )

  return (
    <StoreWrapper>
      <LocationInfo
        disableStore={disableStore}
        isQtyAvailable={isQtyAvailable}
        selected={selected}
        location={location}
      />

      <div>
        <FlexColumnDiv>
          <Button
            text={buttonText}
            size="small"
            onClick={onClick}
            disabled={disableStore || selected}
          />

          {isPrimary && <MyStoreTag />}
        </FlexColumnDiv>
      </div>
    </StoreWrapper>
  )
}

const getButtonText = (
  disabled: boolean,
  isViewOnly: boolean,
  selected: boolean
) => (selected ? 'current' : disabled && isViewOnly ? 'viewOnly' : 'select')

const FlexColumnDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`

const StoreWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding-bottom: 1rem;
  padding-top: 1rem;
  border-bottom: 1px solid #d3d2cf;
  text-align: start;
`
